import React, { createRef } from 'react';
import clsx from "clsx";

export default function Heading(props) {

    const headingRef = createRef();
    const subheadingRef = createRef();

    const data = props.data;
    const updateFormData = props.updateFormData;

    return <div id={data.id} className={clsx('sendiio-form-heading-element', `sendiio-form-heading-alignment-${data.textAlignment}`, `sendiio-form-heading-size-${data.size}`)}>
        <h1 ref={headingRef}
            className="sendiio-form-heading-h1 cursor-text"
            placeholder="Type a header"
            format="text"
            contentEditable={true}
            suppressContentEditableWarning={true}
            onBlur={e => {

                data.title = e.currentTarget.textContent;

                updateFormData(data);

                headingRef.current.textContent = e.currentTarget.textContent;

            }}
            dangerouslySetInnerHTML={{__html: data.title}} />

        <div ref={subheadingRef}
             className="sendiio-form-heading-subtitle cursor-text"
             placeholder="Type a subheader"
             format="text"
             contentEditable={true}
             suppressContentEditableWarning={true}
             onBlur={e => {

                 data.subtitle = e.currentTarget.textContent;

                 updateFormData(data);

                 subheadingRef.current.textContent = e.currentTarget.textContent;

             }}
             dangerouslySetInnerHTML={{__html: data.subtitle}} />

    </div>

}